module.exports = __webpack_public_path__ + "img/bvb-fanabteilung-logo.41aa4673.png";